import React, { useEffect, useMemo } from 'react';
import { fruits, HINT_DURATION } from '../utils/constants';
import { FruitType } from '../utils/types';
import { useNavigate } from 'react-router-dom';

export default function FruitTypes() {
    const navigate = useNavigate()
    useEffect(()=>{
        setTimeout(()=>{
            navigate("/")
        },HINT_DURATION)
    },[])
    const healthyItems = useMemo(() => {
        return fruits.filter(f => f.type === FruitType.Healthy)
    }, [])
    const unHealthyItems = useMemo(() => {
        return fruits.filter(f => f.type === FruitType.Unhealthy)
    }, [])
    return <section className='types-container'>
        <article className='healthy-container'>
            <h2>Healthy</h2>
            <div className='content'>
                {healthyItems.map(f => <div className='item' key={f.id}> <img src={`/assets/${f.name}`} /></div>)}
            </div>
        </article>
        <article className='unhealthy-container'>
            <h2>Unhealthy</h2>
            <div className='content'>
                {unHealthyItems.map(f => <div className='item' key={f.id}> <img src={`/assets/${f.name}`} /></div>)}
            </div>
        </article>
    </section >
}